import { FC, Fragment } from 'react';

import { ContactInfo } from './contact-info';
import { CustomerInfoModel } from '../../../models/customer.model';
import { CustomerMetrics } from './customer-metrics';
import { CustomerJob } from './customer-job';

interface CustomerInfoProps {
    data: CustomerInfoModel;
}

export const CustomerInfo: FC<CustomerInfoProps> = ({ data }) => {
    return (
        <Fragment>
            <ContactInfo className="m-b-2" data={data.contact_info} />

            <CustomerMetrics className="m-b-2" data={data} />

            {data.last_completed_job && (
                <CustomerJob
                    className="m-b-2"
                    title="Last Completed Job"
                    data={data.last_completed_job}
                />
            )}
            {data.next_scheduled_job && (
                <CustomerJob title="Next Scheduled Job" data={data.next_scheduled_job} />
            )}
        </Fragment>
    );
};
